import React, { createContext, useState } from 'react'

export const GlobalState = createContext()

export const DataProvider = ({children}) => {
    const [showMethod, setShowMethod] = useState("table") // to select how to show data (table or cards)
    const [stakedOnly, setStakedOnly] = useState(false) // to switch between staked only (true, false)
    const [dataToShow, setDataToShow] = useState("live") // to switch between live or finished
    const [sortBy, setSortBy] = useState("") // to store sort value
    const [search, setSearch] = useState("") // to store search value

    // export all above wrapping inside 'state' variable
    const state = {
        showMethod: [showMethod, setShowMethod],
        stakedOnly: [stakedOnly, setStakedOnly],
        dataToShow: [dataToShow, setDataToShow],
        sortBy: [sortBy, setSortBy],
        search: [search, setSearch]
    }

    return( 
        <GlobalState.Provider value={state}>
            {children}
        </GlobalState.Provider>
    )
}

